import { useSuspenseQuery } from '@apollo/client';
import { trans } from '@lingoda/i18n';
import { ErrorBoundary } from '@lingoda/monitor';
import { Alert, DialogInfo, Link, Stack, Suspense, Typography } from '@lingoda/ui';
import { RevocationFormWrapper } from '../components/RevocationFormWrapper';
import { formatDocumentDate } from './formatDocumentDate';
import { TermsAndConditionsDocument } from './termsAndConditions.monolith.generated';

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

export const TermsDialog = ({ isOpen, onClose }: Props) => {
    return (
        <DialogInfo
            isOpen={isOpen}
            buttonLabel={trans('form-button-close', {}, 'public-common')}
            title={trans('header', {}, 'public-terms')}
            onClose={onClose}
        >
            <ErrorBoundary fallback={<TermsUnavailable />}>
                <Suspense variant="circular">
                    <TermsAndConditions />
                </Suspense>
            </ErrorBoundary>
        </DialogInfo>
    );
};

const TermsAndConditions = () => {
    const { data } = useSuspenseQuery(TermsAndConditionsDocument);
    const { body, lastUpdatedAt, pdfLink } = data.publicAgreement;

    return (
        <RevocationFormWrapper>
            <div className="translated-item" dangerouslySetInnerHTML={{ __html: body }} />
            {pdfLink && (
                <Link href={pdfLink} target="_blank" download>
                    {trans('btn-download', {}, 'student-common')}
                </Link>
            )}
            <Stack>
                <Typography variant="body1">
                    {trans('latest-update', {}, 'public-terms')}:{' '}
                </Typography>
                <Typography variant="h4">{formatDocumentDate(lastUpdatedAt)}</Typography>
            </Stack>
        </RevocationFormWrapper>
    );
};

const TermsUnavailable = () => {
    return <Alert severity="error">{trans('masked-error', {}, 'errors')}</Alert>;
};
